// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center-text[data-v-58cfdef9] {\r\n  text-align: center;\n}\n.box_size[data-v-58cfdef9] {\r\n  width: 60mm;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-size: 1.2rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
